import { useEffect } from 'react';
import axios from 'axios';
import { useWallet } from '@solana/wallet-adapter-react';
import { UserModel } from '../models';
import { logout } from '../services';

export const useAuthProvider = (
   isAuthenticated: boolean | undefined,
   setIsAuthenticated: (isAuthenticated: boolean | undefined) => void,
   fetchUser: () => void,
   setUser: (user: UserModel | undefined) => void
) => {
   const wallet = useWallet();

   useEffect(() => {
      if (isAuthenticated === undefined) {
         fetchUser();
      }

      if (isAuthenticated === false) {
         setUser(undefined);
         logout();
      }

      if (isAuthenticated) {
         axios.defaults.withCredentials = true;
         axios.interceptors.response.use(
            function (response) {
               return response;
            },
            function (error) {
               if (error?.response?.status === 401) {
                  setIsAuthenticated(false);
                  logout();
               }

               return Promise.reject(error);
            }
         );

         return () => {
            axios.interceptors.response.eject(0);
         };
      }
   }, [isAuthenticated]);

   const logOut = async () => {
      setIsAuthenticated(false);
      wallet?.disconnect();
      logout();
   };

   return {
      logOut,
   };
};
